module.exports = __webpack_public_path__ + "static/media/ResetIcon.e58daff4.svg";